var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.826904H513V342.793H0V0.826904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.826904H513V114.849H0V0.826904Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 228.871H513V342.894H0V228.871Z",
    fill: "#428823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 171.86L0 342.793V0.826904L256.5 171.86ZM309.704 171.86C309.704 148.916 322.829 129.678 344.371 124.969C341.065 124.268 337.658 123.867 334.051 123.867C307.6 123.867 286.058 145.309 286.058 171.86C286.058 198.412 307.499 219.854 334.051 219.854C337.558 219.854 341.065 219.453 344.371 218.752C322.829 213.942 309.704 194.805 309.704 171.86Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.713 130.279L376.033 162.041H409.398L382.345 181.679L392.665 213.441L365.713 193.803L338.66 213.441L348.98 181.679L321.927 162.041H355.393L365.713 130.279Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.967,
    fill: "white",
    transform: "translate(0 0.826904)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEh);
export default __webpack_public_path__ + "static/media/EH.efb08677054aa219a2c96d4e4ca5216c.svg";
export { ForwardRef as ReactComponent };